// Causales de paro — jerarquía 2 niveles (madre → específica).
// Mirror de la tabla `causales_paro` (migración 00002) + helpers para tree.
//
// MIGRACIÓN: el campo `categoria_madre` (enum fijo) fue reemplazado por `categoria_id`
// (FK uuid a `categorias_paro`). Ver migración 20260624000039_categorias_paro_configurables.sql.
import { z } from 'zod';
export const causalParoSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    parent_id: z.string().uuid().nullable(),
    /** FK a `categorias_paro.id` — reemplaza el enum `categoria_madre`. */
    categoria_id: z.string().uuid(),
    codigo: z.string().trim().min(1).max(40),
    nombre: z.string().trim().min(1).max(120),
    requiere_observacion: z.boolean(),
    activa: z.boolean(),
});
/** Tree (madre con hijas) — DTO de `/api/causales-paro` para L2. */
export const causalParoTreeNodeSchema = causalParoSchema.extend({
    hijas: z.array(causalParoSchema),
});
/**
 * Construye el tree a partir de una lista plana de causales. Filtra inactivas
 * por default. Las hijas se ordenan por nombre.
 */
export function buildCausalesTree(causales, options) {
    const includeInactive = options?.includeInactive ?? false;
    const filtered = includeInactive ? [...causales] : causales.filter((c) => c.activa);
    const madres = filtered.filter((c) => c.parent_id === null);
    return madres
        .map((madre) => ({
        ...madre,
        hijas: filtered
            .filter((h) => h.parent_id === madre.id)
            .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es')),
    }))
        .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'));
}
//# sourceMappingURL=causal_paro.js.map